<template>
  <div class="cont">

    <div class="flex-container" v-show="showCalendarResources && !calendarResourceEdit" :class="{'fade-in' : fadeIn}">
      <button @click.prevent="addCalendarResource()" class="btn blue hidden-xs">Ajouter une Ressource</button>
      <button @click.prevent="addCalendarResource()" class="btn blue btn-block visible-xs">Ajouter une Ressource</button>
     <!-- <div class="flex-item hidden-xs" style="margin-top: .5rem">
        <span class="customSpan">Ou</span>
      </div>
      <button @click.prevent="addSupport()" class="btn blue hidden-xs" >Ajouter un renfort</button>
      <button @click.prevent="addSupport()" class="btn blue btn-block visible-xs" style="margin-top: .5rem" >Ajouter un renfort</button>-->
    </div>

    <div style="margin-top: .5rem" >
      <v-select class="fade-in" v-show="isCalendarResource" name="calendar_resource_id" title="Ressources" :items="calendarResources" v-model="current.calendar_resourceId" attributeName="fullName" @clearError="clearError"></v-select>
     <!-- <v-select class="fade-in" v-show="isProvider" name="user_id" title="Prestataires" :items="users" v-model="current.userId" attributeName="fullName" @clearError="clearError"></v-select>
      <v-select class="fade-in" v-show="isSupport"  name="renfort_id" title="Renforts" :items="renforts" v-model="current.renfortId" attributeName="fullName" @clearError="clearError"></v-select>-->
    </div>
    <div class="alert alert-danger"  v-show="error!=''">{{error}}</div>
    <button v-show="isCalendarResource" @click.prevent="addIt(current.calendar_resourceId )" class="btn btn-block green fade-in" style="margin-bottom: .5rem">Ajouter</button>

    <ul class="list-group fade-in" v-show="Object.keys(selected).length != 0">
      <li class="list-group-item fade-in">
        {{ checkType }}
        <span class="bold">{{ fullname }}
          <span class="pull-right"><i class="fas fa-times pointer" @click="removeIt()"></i></span>
        </span>
      </li>
    </ul>

    <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>

  </div>
</template>
<script>
export default {
name: 'soloCalProviders',
props: ['users', 'renforts', 'current', 'calendarResources', 'errors', 'name', 'isEdited', 'quickCreate'],
  data() {
    return {
      selected: {},
      isProvider: false,
      isSupport: false,
      isCalendarResource: false,
      isTypeProvider: false,
      isTypeCalendarResource: false,
      fadeIn: false,
      providerEdit: false,
      calendarResourceEdit: false,
      error: ''
    }
  },
  mounted() {
    this.getSelected(this.current)

    /*if(this.users.length+this.renforts.length==1){//if solo select user
      this.addProvider()
      this.current.userId=this.users[0].id
      this.addIt(this.users[0].id)
    }*/
    this.isEdited ? this.providerEdit = this.isEdited : this.providerEdit = this.quickCreate
  },
  watch:{
    current: {
      deep: true,
      handler(){
        if(!this.isProvider && !this.isSupport){
          this.getSelected(this.current)//force reload of selected encadrant when selecting other booking/event
        }
      }
    }
  },
  computed: {
    fullname() {
      return this.selected.name
    },
    checkType() {
      this.isTypeCalendarResource = true
      return 'Ressource : '
    },
    showProviders() {
      return Object.keys(this.selected).length === 0
    },
    showCalendarResources() {
      return Object.keys(this.selected).length === 0
    }
  },
  methods: {
    getSelected(current_user) {
      if (current_user.calendar_resourceId) {
        this.selected = this.calendarResources.find(calendar_resource => calendar_resource.id === parseInt(current_user.calendar_resourceId))
      }  else {
        this.selected = {}
      }
    },
    addProvider() {
      this.isProvider = !this.isProvider
      this.isSupport = false
    },
    addCalendarResource() {
      this.isCalendarResource = !this.isCalendarResource
      this.isSupport = false
    },
    addSupport() {
      this.isProvider = false
      this.isSupport = !this.isSupport
    },
    addIt(id) {
      if(id!="")
      {
        this.error =""
        const selectedResource = this.calendarResources.find(calendar_resource => calendar_resource.id === id)
        this.isTypeCalendarResource = true
        this.selected = selectedResource
        this.isCalendarResource = !this.isCalendarResource
        this.$emit('input')
      }
      else
      {
        this.error ="Séléctionner une ressource avant de valider"
      }
    },
    removeIt() {
      this.selected = {}
      this.current.calendar_resourceId = ''
      this.isTypeCalendarResource = false
      this.fadeIn = true
      this.calendarResourceEdit = false
      this.$emit('input')
    },
    clearError(e){
      this.$delete(this.errors, e)
    }
  }
};
</script>
<style>
.cont {
  padding: .5rem .5rem 0;
  border: .5px solid #E5E5E5;
  margin-bottom: 13px;
}
.customSpan {
  font-size: 120%;
}
.list-group {
  margin-bottom: 10px!important;
}
.pointer {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap
}

</style>


